import clsx from "clsx";
import { FC, MouseEventHandler, PropsWithChildren } from "react";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { useCrudEditContext } from "@ryde/redux";
import {
  editFormDataAF,
  EditFormMode,
  ICourseDto,
  isInnerItemEditingAtom,
  useIsMobile,
} from "@ryde/shared";

import {
  RelatedEntitiesHeaderIcon,
  RelatedEntitiesHeaderIconContainer,
} from "../../../drawers/components/related-entities";
import {
  LayoutRightHeaderStartButtonsStyled,
  LayoutRightHeaderTitleStyled,
} from "../../../right";
import { CourseHeaderButtons } from "./course.header.buttons";
import { CourseHeaderInfos } from "./course.header.infos";
import { CourseHeaderStyled, HeaderLine1Styled } from "./course.header.styled";

interface ICourseHeaderProps extends PropsWithChildren {
  headerTitle?: string;
  subHeaderTitle?: string;
  closeClick?: MouseEventHandler<Element>;
  drawerNumber?: number;
}

export const CourseHeader: FC<ICourseHeaderProps> = ({
  headerTitle,
  closeClick,
  drawerNumber,
}) => {
  const { isMobile } = useIsMobile();
  const isInnerItemEditing = useRecoilValue(isInnerItemEditingAtom);
  const {
    entity,
    mode,
    data: { isEdit },
  } = useCrudEditContext<ICourseDto>();
  const courseDto = useRecoilValue(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  );

  const titleWithRelations = (
    <RelatedEntitiesHeaderIconContainer>
      <HeaderLine1Styled>{headerTitle}</HeaderLine1Styled>
      {isEdit && (
        <RelatedEntitiesHeaderIcon
          entity={entity}
          entityId={courseDto?.id}
          entityLabel={courseDto?.title || courseDto?.name}
          drawerNumber={drawerNumber}
        />
      )}
    </RelatedEntitiesHeaderIconContainer>
  );

  return (
    <CourseHeaderStyled
      className={clsx(
        "CourseDrawer-Header",
        isInnerItemEditing && "inner-item-editing",
      )}
    >
      <LayoutRightHeaderStartButtonsStyled>
        {closeClick && (
          <SVG_MUI.XMarkSVG onClick={closeClick} className="close" />
        )}
      </LayoutRightHeaderStartButtonsStyled>
      {isMobile && (
        <>
          {titleWithRelations}
          <CourseHeaderButtons />
        </>
      )}
      {!isMobile && (
        <>
          <LayoutRightHeaderTitleStyled className="CourseDrawer-HeaderTitle">
            {titleWithRelations}
            <CourseHeaderInfos />
          </LayoutRightHeaderTitleStyled>
          <CourseHeaderButtons />
        </>
      )}
    </CourseHeaderStyled>
  );
};
